'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var cx = require('classnames');
var Card_types = require('./Card.types.js');
var Card_module = require('./Card.module.scss.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);

var Card = function (_a) {
    var className = _a.className, children = _a.children, _b = _a.size, size = _b === void 0 ? Card_types.CardSizes.md : _b, props = tslib.__rest(_a, ["className", "children", "size"]);
    return (jsxRuntime.jsx("div", tslib.__assign({ className: cx__default.default('card me-2 px-2 py-3', Card_module.default['alloy-card'], Card_module.default["alloy-card--".concat(size)], className) }, props, { children: children })));
};
var Card$1 = Card;

exports.default = Card$1;
//# sourceMappingURL=Card.js.map
